import { PARENT_SITE } from '../../lib/constants';
import { ArrowUpRight } from 'lucide-react';

export const BrandBridge = () => {
  return (
    <section
      data-testid="brand-bridge-section"
      className="bg-brand-bg border-t border-brand-gold/10"
    >
      <div className="container-prep py-16 sm:py-20">
        <a
          href={PARENT_SITE}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="brand-bridge-link"
          className="group relative block max-w-4xl mx-auto rounded-3xl border border-brand-gold/25 bg-brand-bgElev p-8 sm:p-12 hover:border-brand-gold/60 hover:bg-brand-bgSoft transition-all overflow-hidden"
        >
          {/* subtle gold glow on hover */}
          <div
            aria-hidden
            className="absolute -top-1/2 -right-1/2 w-[600px] h-[600px] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700"
            style={{ background: 'radial-gradient(circle, rgba(201,169,110,0.15) 0%, transparent 60%)' }}
          />

          <div className="relative flex flex-col sm:flex-row items-start sm:items-center gap-8">
            <div className="flex-1">
              <p className="eyebrow mb-4">The Full Prép Experience</p>
              <h3 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-brand-cream leading-tight">
                Also offering lash extensions,
                <span className="italic block text-brand-gold">hair colour &amp; brow services.</span>
              </h3>
              <p className="mt-5 text-brand-muted text-base sm:text-lg leading-relaxed max-w-xl">
                Prép Beauty Parlour is a full-service downtown Vancouver studio.
                Book your YUMI lash lift alongside hair, brows, or nails —
                one address, one team, one appointment.
              </p>
            </div>

            <div className="shrink-0 flex items-center gap-3 self-start sm:self-center">
              <span className="hidden sm:inline text-sm font-medium text-brand-cream/85 group-hover:text-brand-gold transition-colors whitespace-nowrap">
                Visit Prép Beauty Parlour
              </span>
              <span className="w-14 h-14 rounded-full bg-brand-gold text-brand-ink flex items-center justify-center group-hover:bg-brand-goldWarm group-hover:scale-110 transition-all">
                <ArrowUpRight size={22} />
              </span>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
};

export default BrandBridge;
